/* istanbul ignore file */
export enum LanguageActionTypesEnum {
	CHANGE_LANGUAGE = 'language/change'
}
